import { navLinks } from "../data";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-background-200/60 border-t border-background-300">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
          {/* brand */}
          <div className="md:col-span-4">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-full bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-camera-lens-fill text-lg"></i>
              </span>
              <span className="font-heading text-xl font-extrabold text-foreground-950">
                搭讪<span className="text-primary-600">吃瓜</span>
              </span>
            </a>
            <p className="mt-4 text-sm leading-6 text-foreground-600 max-w-sm">
              聚焦街头搭讪实拍争议、视频伦理与路人隐私的独立观察媒体。吃瓜也要讲道理，一起把争议聊清楚。
            </p>
            <div className="mt-5 flex gap-2">
              {["ri-weibo-line", "ri-bilibili-line", "ri-douban-line", "ri-wechat-line"].map((ic) => (
                <a
                  key={ic}
                  href="#top"
                  aria-label="关注我们"
                  className="w-9 h-9 rounded-full bg-background-50 border border-background-300 text-foreground-700 hover:bg-primary-500 hover:text-background-50 hover:border-primary-500 flex items-center justify-center transition"
                >
                  <i className={ic}></i>
                </a>
              ))}
            </div>
          </div>

          {/* columns */}
          <div className="md:col-span-2">
            <h3 className="font-heading text-sm font-bold text-foreground-950">栏目导航</h3>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((l) => (
                <li key={l.id}>
                  <a href={`#${l.id}`} className="text-sm text-foreground-600 hover:text-primary-600 transition whitespace-nowrap">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h3 className="font-heading text-sm font-bold text-foreground-950">热门关键词</h3>
            <div className="mt-4 flex flex-wrap gap-2">
              {["搭讪实拍争议", "搭讪视频伦理", "搭讪路人隐私", "搭讪视频下架", "搭讪拍摄争议", "街头拍摄边界", "路人肖像权", "平台治理"].map((k) => (
                <a
                  key={k}
                  href="#focus"
                  className="px-3 py-1.5 rounded-full bg-background-50 border border-background-300 text-xs text-foreground-600 hover:border-primary-300 hover:text-primary-600 transition whitespace-nowrap"
                >
                  {k}
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <h3 className="font-heading text-sm font-bold text-foreground-950">投稿与联系</h3>
            <p className="mt-4 text-sm leading-6 text-foreground-600">
              发现新线索、想投稿或提意见？欢迎来信。
            </p>
            <a
              href="mailto:hello@dashanchigua.example.com"
              className="mt-2 inline-flex items-center gap-2 text-sm text-primary-700 font-medium hover:text-primary-800 whitespace-nowrap"
            >
              <i className="ri-mail-line"></i> hello@dashanchigua.example.com
            </a>
            <a
              href="#contact"
              className="mt-4 h-10 px-5 inline-flex items-center rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium transition whitespace-nowrap"
            >
              在线投稿表单
            </a>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-300 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © {year} 搭讪吃瓜 · 本号内容为公共议题观察与讨论，仅作信息参考，不构成法律意见。
          </p>
          <p className="text-xs text-foreground-500">理性吃瓜 · 尊重每一位真实路人</p>
        </div>
      </div>
    </footer>
  );
}